/**
 * /sign-in: the one sign-in page, with wording for whoever is arriving. `?for=staff` is where the
 * admin app sends a signed-out staff member, `?for=clinic` is the clinic portal's, and anything else
 * is a customer. Every one of them signs in the same way, by a code sent to their email.
 */
import { useEffect } from "react";
import { AuthLayout, nextPath } from "./AuthLayout.tsx";
import { EmailCodeSignIn } from "./EmailCodeSignIn.tsx";

const COPY = {
  staff: {
    title: "Lattice staff sign-in",
    lead: "Enter your work email. We'll send a six-digit code, then ask for your authenticator.",
  },
  clinic: {
    title: "Clinic sign-in",
    lead: "Enter the email your clinic invited. We'll send a six-digit code.",
  },
  customer: {
    title: "Sign in to Lattice",
    lead: "Enter your email. We'll send a six-digit code. No password.",
  },
} as const;

function audience(): keyof typeof COPY {
  const asked = new URLSearchParams(window.location.search).get("for");

  return asked === "staff" || asked === "clinic" ? asked : "customer";
}

export function SignIn() {
  const copy = COPY[audience()];

  useEffect(() => {
    document.title = `${copy.title} · Lattice`;
  }, [copy.title]);

  return (
    <AuthLayout title={copy.title} lead={copy.lead}>
      <EmailCodeSignIn next={nextPath()} />
    </AuthLayout>
  );
}
